import { Info } from "../alert";
import { Link } from "../link";

export const ArrayFanOutTip = ({
  destinationName = "this destination",
}) => (
  <Info>
    If you map an identifier field that contains an array of values,
    Hightouch automatically fans out each element into a separate record
    when syncing to {destinationName}. Learn more about{" "}
    <Link variant="inline" href={"/syncs/array-identifier-fan-out"}>
      array identifier fan-out
    </Link>
    .
  </Info>
);
